import { fade } from '@material-ui/core/styles/colorManipulator';

export default theme => ({
    button: {
        padding: theme.spacing.unit,
        fontSize: theme.spacing.unit,
        color: fade(theme.palette.primary.dark, 0.75)
    }
});
